<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import httpUrls from "./components/config/HttpUrlConfig.js";
export default {
  name: "app",
  created: function () {
    //将数据写入Url数据componentsMoudel,开启数据持久化
    this.componentsMoudel.openLocalStorage("crFactoryPlatForm");
    // this.componentsMoudel.closeLocalStorage();
    this.componentsMoudel.setData("urls", httpUrls);
    document.title = "";
    let infos = JSON.parse(localStorage.getItem("D3Config"));

    // if(Object.keys(infos).length) {
    //   // let D3Info = require('./utils/D3Config');
    //   // this.D3Config.models = infos.models.map(v => {
    //   //   return {
    //   //     id:v.id,
    //   //     name: v.type,
    //   //     coors: [Number(infos.longitude), Number(infos.latitude)],
    //   //     heading: Number(v.heading),
    //   //     pitch: Number(v.pitch),
    //   //     scale: Number(v.scale),
    //   //     rotateZ: Number(v.rotateZ),
    //   //     modelUrl: `${v.url}`
    //   //   }
    //   // })
    //   // console.log(this.D3Config, 'ssss')
    //   this.D3Config.title = infos.name
    //   this.D3Config.base_url = infos.serviceIp
    //   this.D3Config.username = infos.serviceUserName
    //   this.D3Config.password = infos.servicePassword
    //   this.D3Config.Camera.center[0] = Number(infos.longitude)
    //   this.D3Config.Camera.center[1] = Number(infos.latitude)
    // }
  },
  beforeUpdate: function () {
    this.componentsMoudel.setData("urls", httpUrls);
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* iview 弹窗的zindex值 */
/deep/ .ivu-modal-mask {
  z-index: 1000;
}
/deep/ .ivu-modal-wrap {
  z-index: 1000;
}

 ::-webkit-scrollbar-track-piece {
  background: #d3dce6;
}

 ::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: #99a9bf;
  border-radius: 20px;
}
</style>
